import React, {PropsWithChildren} from 'react';

type CardModifiers = 'secondary' | 'grid';

interface CardProps {
    header?: JSX.Element | string;
    modifiers?: CardModifiers[];
    onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
    onDrop?: (e: React.DragEvent<HTMLDivElement>) => void;
    onDragOver?: (e: React.DragEvent<HTMLDivElement>) => void;
}

function Card(props: PropsWithChildren<CardProps>): JSX.Element {
    const {header, modifiers = [], onClick, onDrop, onDragOver, children} = props;

    return (
        <div
            className={`c-card ${getModifiers(modifiers)}`}
            onClick={onClick}
            onDrop={onDrop || undefined}
            onDragOver={onDragOver || undefined}
        >
            {header && <span className="c-card__header">{header}</span>}
            <div className="c-card__content">{children}</div>
        </div>
    );
}

function getModifiers(modifiers?: CardModifiers[]): string {
    if (modifiers) {
        return modifiers.map((item) => 'c-card--'.concat(item)).join(' ');
    }

    return '';
}

export default Card;
